/* template */
<template><div :class="({'worry-free': serviceType === 2 && isAboutToDepart})" :id='("right-card-"+(serviceType))' class="card-container"><div :class="({'no-bottom': serviceType === 2 && isAboutToDepart})" class="rights-select-card"><div :class="({'less-top': couponAmountDesc})" class="rights-select-card-desc"><div class="rights-select-card-desc-left"><div class="rights-select-card-desc-price" v-if="(Number.isFinite(seatPrice) && seatPrice >= 0)"><div class="amount"><div class="signal">¥</div>{{ seatPrice }}</div></div><div class="allowance" v-if="(couponAmountDesc)">{{ couponAmountDesc }}</div></div><div class="rights-select-card-desc-hightlight" v-if="(!is12306Right && extrudeTips.title)"><div :style='[("color: "+(serviceIconColor))] | transRpxStyle' class="rights-select-card-desc-hightlight-top"><mpx-image :src="(hightlightIcon)" class="icon"/>{{ extrudeTips.title }}</div><div class="rights-select-card-desc-hightlight-bottom" v-if="(extrudeTips.subhead)">{{
            extrudeTips.subhead
          }}</div></div><mpx-view :class="({'scramble': isScramble || isPreScramble})" @tap="handleClick" class="rights-select-card-btn"><div :class="({'remaining': remainingText})" class="btn-text">{{ btnText }}</div><div class="remain-text" v-if="(remainingText)">{{ remainingText }}</div></mpx-view></div><mpx-view @tap="openRightsDescDrawer" class="rights-select-card-benefits" v-if="(serviceTipArr.length || serviceSubTitle)"><spring-icon h="16" w="8" :color="(serviceIconColor)" name="right-thin-arrow" :externClass='["arrow-icon"].join(" ")' v-if="(!is12306Right)"/><div :style='[("background: "+(serviceMaskColor))] | transRpxStyle' class="mask" v-if="(!is12306Right)"></div><div :class="({'gray' : is12306Right})" class="divider"/><div :style='[("color: "+(serviceTextColor))] | transRpxStyle' class="rights-select-card-benefits-desc"><div :style="[(serviceTitleColor)] | transRpxStyle" class="rights-select-card-benefits-desc-title" v-if="(!is12306Right)">{{ serviceTitle }}</div><div :style='[("color: "+(serviceIconColor))] | transRpxStyle' class="rights-select-card-benefits-desc-price" v-if="(Number.isFinite(serviceFee) && serviceFee >= 0 && !is12306Right)"><div class="unit">+</div>¥{{ serviceFee }}</div><div v-for="(item, index) in (serviceTipArr)" :key="item.index" class="tip" v-if="(!is12306Right)"><spring-icon :color="(serviceIconColor)" h="15" w="16" name="marketing-check-mark" :externClass='["check-icon"].join(" ")'/><div class="text">{{ item }}</div></div><div class="sub-title" v-if="(is12306Right)">{{ serviceSubTitle }}</div></div></mpx-view></div></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m096da42e"}'>
  @font-face
    font-family MFYuanHei
    src url('https://ut-static.udache.com/webx/sfc/zFeca_fdUIuxJfpXUFGY5_ZaoZiGongFangYuanHeiTi-2-Medium.otf')
  .worry-free
    padding 36px 2px 2px 2px
    box-sizing border-box
    background-image url('https://ut-static.udache.com/webx/sfc/PDidbSnP44ohqJJlQhtAH.png')
    background-size 100% auto
    background-repeat no-repeat
    background-position top center
    margin-bottom 10px
    border-radius 10px
  .rights-select-card
    width 100%
    display flex
    flex-direction column
    background-color #fff
    border-radius 8px
    margin-bottom 10px
    &.no-bottom
      margin-bottom 0
    &-desc
      display flex
      justify-content space-between
      padding 18px 16px
      padding-left 15px
      align-items center
      box-sizing border-box
      &.less-top
        padding-top 15px
      &-left
        display flex
        flex-direction column
        align-items flex-start
        .subtitle
          margin-top 4px
          font-family PingFangSC-Regular
          font-weight 400
          font-size 11px
          line-height 12px
          color #999
        .allowance
          margin-top 4px
          position relative
          box-sizing border-box
          padding 2px
          font-family PingFangSC-Regular
          font-weight 400
          line-height 10px
          font-size 10px
          color #FF6400
          &::after
            position absolute
            height 200%
            width 200%
            border-radius 8px
            border 1px solid #FFBC91
            content ''
            transform scale(0.5)
            top 0
            left 0
            transform-origin 0 0
      &-hightlight
        display flex
        flex-direction column
        &-top
          display flex
          align-items center
          font-family PingFangSC-Medium
          font-weight 500
          font-size 13px
          line-height 12px
          .icon
            height 14px
            width 14px
            margin-right 4px
        &-bottom
          font-size 11px
          line-height 12px
          color #999
          font-family PingFangSC-Regular
          font-weight 400
          margin-top 8px
      &-price
        display flex
        align-items center
        .amount
          display flex
          align-items baseline
          font-family Barlow Semi Condensed
          font-size 28px
          line-height 28px
          color #FF6400
          .signal
            font-family PingFangSC-Semibold
            font-size 16px
            font-weight 600
            line-height 16px
            margin-right 2px
      &-service
        font-family PingFangSC-Regular
        font-weight 400
        font-size 11px
        line-height 16px
        margin-bottom 1px
        margin-left 5px
        color #666
        align-self flex-end
    &-btn
      box-sizing border-box
      border-radius 10px
      height 44px
      width 44px
      display flex
      flex-direction column
      align-items center
      font-family PingFangSC-Medium
      font-weight 500
      font-size 18px
      line-height 18px
      color #fff
      background #FF6400
      .btn-text
        margin-top 13px
        &.remaining
          margin-top 6px
      .remain-text
        width 40px
        height 14px
        display flex
        align-items center
        justify-content center
        font-family PingFangSC-Medium
        font-weight 500
        font-size 10px
        background #fff
        border-radius 0 0 8px 8px
        color #FF6400
        margin-top 4px
      &.scramble
        background #FF4129
    &-benefits
      width 100%
      position relative
      display flex
      align-items flex-start
      overflow hidden
      .mask
        position absolute
        z-index 1
        content ''
        top 0
        left 0
        height 100%
        width 100%
        border-radius 0 0 8px 8px
        background linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 20%, rgba(255, 255, 255, 0) 79%, #FFFFFF 100%), linear-gradient(180deg, rgba(51, 143, 255, 0.1) 0%, rgba(51, 143, 255, 0) 100%)
      .divider
        position absolute
        width 100%
        height 1px
        opacity 0.8
        background-image linear-gradient(90deg, rgba(51, 143, 255, 0.2) 0%, rgba(51, 143, 255, 0.08) 100%)
        left 0
        top 0
        transform scaleY(0.5) translateY(-100%)
        &.gray
          background #eee
          opacity 1
      &-img
        z-index 20
        height 18px
        margin-top 12px
        margin-left 16px
      .arrow-icon
        z-index 20
        position absolute
        bottom 5px
        right 12px
        transform translate(100%, -50%)
      &-desc
        position relative
        z-index 2
        width calc(100% - 36px)
        display flex
        overflow-x auto
        padding 8px 0px
        margin-left 16px
        box-sizing border-box
        border-radius 0 0 8px 8px
        &-title
          line-height 12px
          flex-shrink 0
          margin-right 4px
          font-size 12px
          font-family MFYuanHei
        &-price
          flex-shrink 0
          display flex
          align-items baseline
          font-family PingFangSC-Medium
          font-weight 500
          line-height 12px
          font-size 11px
          margin-right 16px
          opacity 0.9
          .unit
            display flex
            align-items flex-end
            height 12px
            line-height 1
        .tip
          position relative
          flex-shrink 0
          display flex
          flex-wrap nowrap
          align-items center
          border-radius 0 0 8px 8px
          &:not(:last-child)
            margin-right 8px
          .check-icon
            margin-right 3px
          .text
            font-size 11px
            line-height 12px
            font-family PingFangSC-Regular
            font-weight 400
        .sub-title
          font-size 11px
          line-height 12px
          font-family PingFangSC-Regular
          font-weight 400
          color #999
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m096da42e"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./seat-rights-select-card.mpx.js?isComponent&outputPath=components%2Fseat-rights-select-card096da42e%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./seat-rights-select-card.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fseat-rights-select-card096da42e%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m096da42e"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/seat-rights-select-card096da42e/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'spring-icon':getComponent(require("../../../../../node_modules/@didi/spring-icon/index/index.mpx?isComponent&outputPath=components%2Findex4d1d0d54%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
